export default __webpack_public_path__ + "assets/webgl/bonus.5e3f3bb0.png";